import { create } from 'zustand';
import { GetNapsParams,getNaps } from '@/shared/actions/erp';
import {Naps } from '@/shared/interfaces';


interface INapsStore {
    naps: Naps[];
    isLoadingNaps: boolean;
    getNaps: (params?: GetNapsParams) => Promise<void>;
}

export const useNapsStore = create<INapsStore>((set) => ({
    naps: [],
    isLoadingNaps: false,
    getNaps: async (params) => {
        set({isLoadingNaps: true});
        const resp= await getNaps(params);
        set({naps: resp.data.data, isLoadingNaps: false});
    },
}));